export default __webpack_public_path__ + "static/media/151-cleaned.62d91d75.png";